export default __webpack_public_path__ + "static/media/view-blend.f6e50c39.webp";